/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const ContentBundleItem = types.model('ContentBundleItem', {
  globalBookId: types.maybeNull(types.string),
  bookId: types.maybeNull(types.string),
  bundleLabel: types.maybeNull(types.string),
  bundleUri: types.optional(types.array(types.string), []),
  createdBy: types.maybeNull(types.string),
  bundleId: types.maybeNull(types.string),
  startPointTitle: types.maybeNull(types.string),
  endPointTitle: types.maybeNull(types.string)
});

const ContentBundle = types
  .model('ContentBundle', {
    bundles: types.optional(types.array(ContentBundleItem), []),
    saveStatus: types.optional(types.string, ''),
    deleteStatus: types.optional(types.string, ''),
    lastUpdated: types.optional(types.number, 0),
    tocData: types.optional(types.array(types.frozen()), [])
  })
  .actions((self) => ({
    fetchBundles(bookId) {
      Framework.getEventManager().publish(constants.CONTENT_BUNDLE_FETCHED, { bookId });
    },
    saveBundles(payload) {
      Framework.getEventManager().publish(constants.CONTENT_BUNDLE_SAVE, { payload });
    },
    deleteBundle(event) {
      Framework.getEventManager().publish(constants.CONTENT_BUNDLE_DELETE, event);
    },
    setSaveStatus(status) {
      /* eslint-disable no-param-reassign */
      self.saveStatus = status;
      /* eslint-enable no-param-reassign */
    },
    setDeleteStatus(status) {
      /* eslint-disable no-param-reassign */
      self.deleteStatus = status;
      /* eslint-enable no-param-reassign */
    },
    setLastUpdated() {
      /* eslint-disable no-param-reassign */
      self.lastUpdated = Date.now();
      /* eslint-enable no-param-reassign */
    },
    removeBundle(event) {
      /* eslint-disable no-param-reassign */
      if (event.bundleId) {
        self.bundles = self.bundles.filter((b) => b.bundleId !== event.bundleId);
      } else if (event.bundleName) {
        self.bundles = self.bundles.filter((b) => b.bundleLabel !== event.bundleName);
      }
      /* eslint-enable no-param-reassign */
    },
    setBundles(response) {
      applySnapshot(self.bundles, response);
    },
    setTocData(data) {
      /* eslint-disable no-param-reassign */
      self.tocData = data;
      /* eslint-enable no-param-reassign */
    }
  }));

export default ContentBundle;
